import styled from 'styled-components';

const sizeEnum = {
    sm: '12px',
    med: '48px',
    lg: '144px',
};

const StyledColourSwatch = styled.div`
    width: ${props => sizeEnum[props.size]};
    height: ${props => sizeEnum[props.size]};
    background-color: ${props => `hsl(${props.colour.hue}, ${props.colour.saturation}%, ${props.colour.lightness}%)`};
    border-radius: 12px;
    opacity: ${({ invisible }) => (invisible ? 0 : 1)};
    cursor: ${({ invisible }) => (invisible ? 'default' : 'pointer')};
`;

export const ColourSwatch = ({ id, colour, size, onClick, invisible = false, testId }) => {
    return (
        <div onClick={onClick}>
            <StyledColourSwatch data-testid={testId} id={id} colour={colour} size={size} invisible={invisible}></StyledColourSwatch>
        </div>
    );
};
